import { Box } from '@chakra-ui/react';
import { FC } from 'react';

import { Button } from '@bonusly/ds-button';
import { Tooltip } from '@bonusly/ds-tooltip';

import { useDarkMode } from '../hooks/use-dark-mode';

export interface DarkModeToggleProps {
	/** When true, hides the toggle (e.g., when seasonal theme is active) */
	isHidden?: boolean;
}

export const DarkModeToggle: FC<DarkModeToggleProps> = ({ isHidden = false }) => {
	const { isDarkMode, canToggleDarkMode, toggleDarkMode } = useDarkMode();

	// Only show toggle if user has feature flag and it's not hidden
	if (!canToggleDarkMode || isHidden) {
		return null;
	}

	return (
		<Tooltip label={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'} placement="left">
			<Box>
				<Button
					aria-label={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
					onClick={toggleDarkMode}
					size="sm"
					variant="ghost"
					transition="all 0.2s"
					_hover={{
						transform: 'scale(1.2)',
					}}
				>
					{isDarkMode ? '☀️' : '🌙'}
				</Button>
			</Box>
		</Tooltip>
	);
};
